// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PawPrintBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M29.5 13.5a3 3 0 1 1-5.999 0 3 3 0 0 1 5.999 0Zm-21 0a3 3 0 1 0-6 0 3 3 0 0 0 6 0Zm3-3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm9 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm6 12.5a5.5 5.5 0 0 1-7.637 5.069 7.518 7.518 0 0 0-5.726 0 5.5 5.5 0 0 1-4.762-9.901 3.916 3.916 0 0 0 1.864-2.343 5.999 5.999 0 0 1 11.522 0c.287.997.957 1.84 1.864 2.343A5.5 5.5 0 0 1 26.5 23Zm-3 0a2.5 2.5 0 0 0-1.311-2.2l-.013-.008a6.902 6.902 0 0 1-3.296-4.125 3 3 0 0 0-5.76 0A6.902 6.902 0 0 1 9.824 20.8l-.013.007A2.5 2.5 0 0 0 11 25.5c.335 0 .667-.066.975-.198h.016a10.5 10.5 0 0 1 8.018 0h.016A2.5 2.5 0 0 0 23.5 23Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
